<template>
  <div class="user-page full-height">
    <tableCon>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/arrivalOrders' }">到货订单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input
                  aria-placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.id"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.userName"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">国内运单号:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.trackingNumberCn"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">国际运单号:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.trackingNumberJpn"
                  size = "small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col> -->
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">仓库保管:</div>
              <div class="flex1">
                <el-select
                  v-model="queryInfo.categoryFlag"
                  placeholder="请选择"
                  size="small"
                  clearable
                >
                  <el-option
                    key="1"
                    value="1"
                    label="是"
                  ></el-option>
                  <el-option
                    key="0"
                    value="0"
                    label="否"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">订单状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.orderStatus" placeholder="请选择" size="small" clearable>
                  <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->

            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">下单开始日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">下单结束日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">发送开始日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.sendTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col
              :span="6"
              class="display-row"
            >
              <!--<div class="query-title">发送结束日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.sendTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>-->
              <div class="query-title">商品编码:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入商品编码"
                  clearable
                  v-model="queryInfo.goodsCode"
                  size="small"
                  @keyup.enter.native="searchList()"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">

          <el-col
            :span="6"
            class="display-row"
          >
            <div
              style="width: 166px;"
              class="query-title"
            >FBA/YFF/ZOZO/RSL:</div>
            <div class="flex1">
              <el-select
                v-model="queryInfo.orderType"
                placeholder="请选择"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in fbaOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                > </el-option>
              </el-select>
            </div>
          </el-col>
          <!-- <el-col :span="6" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col> -->
        </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col
            :span="14"
            class="display-row"
          >
            <div class="search-btn-container search-btn-container-status">
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === ''}"
                @click="changeTab('')"
              >全部
              </el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 4}"
                @click="changeTab(4)"
              >到库<span class="lx-red">({{orderCount.arrivalCount}})</span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 8}"
                @click="changeTab(8)"
              >验货中<span class="lx-red">({{orderCount.checkingCount}})</span></el-button>
              <!-- <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}" @click="searchList(12,index = 3)">检品完<span class="lx-red">({{orderCount.checkedCount}})</span></el-button> -->
              <!-- <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 4}" @click="searchList(20,index = 4)">申请发货<span class="lx-red">({{orderCount.applySendCount}})</span></el-button> -->
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 88}"
                @click="changeTab(88)"
              >装箱中<span class="lx-red">({{orderCount.boxCount}})</span></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{lxBtnGreenDeep: curIndex === 48}"
                @click="changeTab(48)"
              >待发送<span class="lx-red">({{orderCount.waitSendCount}})</span></el-button>
            </div>
          </el-col>
          <el-col
            :span="10"
            class="display-row"
          >
            <div class="search-btn-container">
              <el-button
                class="search-btn btn-blue"
                @click="createPacking"
              >新建装箱单</el-button>
              <el-button
                class="search-btn btn-gray"
                @click="queryInfoClear"
              >重置</el-button>
              <el-button
                class="search-btn btn-blue"
                @click="searchList()"
              >搜索</el-button>
              <el-button
                class="search-btn btn-blue"
                @click="toSort"
              >排序</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div
        slot="table"
        class="full-height display-col"
      >
        <el-table
          :data="orderList"
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          v-loading="isLoading"
          border
          ref="multipleTable"
          stripe
          style="width: 100%"
          height="550"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="40"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in asyncColumns"
            :key="index"
            align="center"
            :label="item.name"
            :prop="item.key"
            :width="item.width?item.width:'auto'"
            :min-width="item.minWidth?item.minWidth:'auto'"
          >
            <template v-slot="scope">
              <!-- 操作 -->
              <div
                v-if="item.key === 'handle'"
                style="display: inline-block"
                class="btn-row"
              >
                <el-button
                  class="list-btn-four btn-blue"
                  @click="toOrderDetail(scope.row)"
                >详情</el-button>
                <el-button
                  v-if="editStatus.indexOf(scope.row.orderStatus)<0"
                  class="list-btn-four btn-deepblue"
                  @click="toEditOrder(scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="spiltStatus.indexOf(scope.row.orderStatus) > -1"
                  class="list-btn-four btn-deepblue"
                  @click="splitOrder(scope.row)"
                >拆单</el-button>
                <!-- <el-button
                  v-if="billStatus.indexOf(scope.row.orderStatus) > -1"
                  class="list-btn-four btn-blue"
                  @click="toBill(scope.row)"
                >账单</el-button> -->
              </div>
              <!-- 工作签 -->
              <div v-else-if="item.key === 'staffRemark'">
                <el-input
                  type="textarea"
                  @blur="quickSave(scope.row.staffRemark,'5',scope.row.id)"
                  placeholder="请输入采购内容"
                  v-model="scope.row.staffRemark"
                  size="small"
                >
                </el-input>
                <el-input
                  style="padding-top:5px"
                  type="textarea"
                  @change="quickSave(scope.row.checkRemark,'6',scope.row.id)"
                  placeholder="请输入检品内容"
                  v-model="scope.row.checkRemark"
                  size="small"
                >
                </el-input>
              </div>
              <!-- 产品描述 -->
              <div v-else-if="item.key === 'productDesc'">
                <el-input
                  type="textarea"
                  @change="quickSave(scope.row.productDesc,'0',scope.row.id)"
                  placeholder="请输入内容"
                  v-model="scope.row.productDesc"
                  size="small"
                >
                </el-input>
              </div>
              <!-- 国内物流 -->
              <div v-else-if="item.key === 'trackingNumberCn'">
                <div>{{scope.row.trackingNumberCn}}</div>
                <div
                  class="overflowDot"
                  :title="scope.row.cnLogisticsStatus"
                >{{scope.row.cnLogisticsStatus}}</div>
              </div>
              <!-- 国际物流 -->
              <!-- <div v-else-if="item.key === 'trackingNumberJpn'">
                <div>{{scope.row.trackingNumberJpn}}</div>
                <div class="overflowDot" :title="scope.row.sagawaState">{{scope.row.sagawaState}}</div>
              </div> -->
              <!-- 中国运费 -->
              <!-- <div v-else-if="item.key === 'chineseFreightFee'">
                <el-input
                  @blur="quickSave(scope.row.chineseFreightFee,'1',scope.row.id)"
                  v-model="scope.row.chineseFreightFee"
                  type="tel"
                  :maxlength="12"
                  oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
                ></el-input>
              </div> -->
              <!-- 单价 -->
              <div v-else-if="item.key === 'price'">
                <el-input
                  @blur="quickSave(scope.row.price,'2',scope.row.id)"
                  v-model="scope.row.price"
                  type="tel"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                ></el-input>
              </div>
              <!-- 用户备注 -->
              <div v-else-if="item.key === 'customerRemark'">
                <el-input
                  type="textarea"
                  placeholder=""
                  v-model="scope.row.customerRemark"
                  size="small"
                  disabled
                >
                </el-input>
              </div>
              <!-- 购买订单号 -->
              <div v-else-if="item.key === 'buyOrderNumber'">
                <el-input
                  maxlength="50"
                  @blur="quickSave(scope.row.buyOrderNumber,'3',scope.row.id)"
                  v-model="scope.row.buyOrderNumber"
                ></el-input>
              </div>
              <!-- 购买账号 -->
              <div v-else-if="item.key === 'buyAccountId'">
                <el-select
                  v-model="scope.row.buyAccountId"
                  @change="quickSave(scope.row.buyAccountId,'4',scope.row.id)"
                  placeholder="请选择"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="item in buyAcountList"
                    :key="item.id"
                    :label="item.platformType_hanzi"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <!-- 订单状态 -->
              <div v-else-if="item.key === 'orderStatus'">
                {{scope.row.orderStatus | orderStatusFilter}}
              </div>
              <!-- 是否为FBA -->
              <div v-else-if="item.key === 'isFBA'">
                {{scope.row.orderType | ordertypeFilter}}
                <div> <span style="margin-right:10px">コード:</span>{{scope.row.fnsku}}</div>
                <div> <span style="margin-right:10px">品名:</span>{{scope.row.goodsNameCus}}</div>
                <div> <span style="margin-right:10px">ASIN:</span>{{scope.row.asin}}</div>
              </div>
              <!-- 商品数量 -->
              <div v-else-if="item.key === 'goodsCount'">
                <div>
                  <span>总数量：</span>
                  <span>{{scope.row.goodsCount}}</span>
                </div>
                <div>
                  <span>待装箱：</span>
                  <span>{{scope.row.waitBoxCount}}</span>
                </div>
<!--                <div>
                  <span>退货：</span>
                  <span>{{scope.row.refundCount}}</span>
                </div>
                <div>
                  <span>销毁：</span>
                  <span>{{scope.row.destroyCount}}</span>
                </div>-->
              </div>
              <!-- 检品 -->
              <div v-else-if="item.key === 'inspection'">
                <span v-if="scope.row.inspection&&scope.row.inspection.length>0">
                  <div
                    v-for="item in scope.row.inspection.split(',')"
                    :key="item"
                  >
                    {{item}}
                  </div>
                </span>
              </div>
              <!-- 仓库保管 -->
              <!-- <div v-else-if="item.key === 'categoryFlag'">
                {{scope.row.categoryFlag == 0 ? '否' :'是'}}
              </div> -->
              <!-- 包装意向 -->
              <div v-else-if="item.key === 'putIntent'">
                {{scope.row.putIntent | putIntentFilter}}
              </div>
              <!-- 商品信息 -->
              <div v-else-if="item.key === 'goodsInfo'">
                <div class="div" v-if="scope.row.colour">
                  <span class="table-cell-title-min-new">颜色：</span>
                  <span class="span">{{scope.row.colourCn || scope.row.colour}}</span>
                </div>
                <div class="div" v-if="scope.row.goodsSize">
                  <span class="table-cell-title-min-new">尺寸：</span>
                  <span class="span">{{scope.row.goodsSizeCn || scope.row.goodsSize}}</span>
                </div>
                <div class="div" v-if="scope.row.goodsNumber">
                  <span class="table-cell-title-min-new">品番：</span>
                  <span class="span">{{scope.row.goodsNumber}}</span>
                </div>
                <div class="div" v-if="scope.row.goodsCode">
                  <span class="table-cell-title-min-new">商品编码：</span>
                  <span class="span">{{scope.row.goodsCode}}</span>
                </div>
              </div>
              <!-- 图片 -->
              <div v-else-if="item.key === 'picture'">
                <img
                  @paste="onPasteUpload"
                  @click="imgclick(scope.row,scope.$index)"
                  v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0"
                  :src="scope.row.pictureUrl"
                  alt=""
                  class="list-image"
                >
                <img
                  v-else
                  @click="imgclick(scope.row,scope.$index)"
                  src="@/assets/images/default.png"
                  alt=""
                  class="list-image"
                >
                <div class="btn-row">
                  <el-button
                    class="list-btn-four btn-blue"
                    @click="toGoodsDetail(scope.row)"
                  >
                    商品详情
                  </el-button>
                </div>
              </div>
              <!-- 不良待处理 -->
              <!-- <div v-else-if="item.key === 'badCount'">
                <div>
                  <span>不良待处理：</span>
                  <span>{{scope.row.badCount}}</span>
                </div>
                <div>
                  <span>换货中：</span>
                  <span>{{scope.row.exchangCount}}</span>
                </div>
                <div>
                  <span>补发中：</span>
                  <span>{{scope.row.reissueCount}}</span>
                </div>
              </div> -->

<!--              &lt;!&ndash;检品视频&ndash;&gt;
              <div  v-else-if = "item.key === 'playVideo'" >
                <div v-if="scope.row.checkVideo" >
                  <el-button class="list-btn btn-green"
                             @click="handlePlayVideo(scope.row.checkVideo)">播放</el-button>
                </div>
              </div>-->

              <!-- 其他不需要处理的 -->
              <span v-else>
                {{scope.row[item.key]}}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </tableCon>
    <!-- 拆单 -->
    <el-dialog
      title="拆单"
      :visible.sync="splitDialogVisible"
      width="90%"
      @close="splitDialogClosed"
    >
      <el-row>
        <el-col
          :span="12"
          class="split-col"
        >
          <el-form
            label-width="120px"
            class="demo-ruleForm"
          >
            <div class="split-title">
              原订单信息：
            </div>
            <div>
              <el-form-item label="原订单编号：">
                <el-input
                  v-model="orginSplitOrderInfo.id"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="订单状态">
                <el-select
                  v-model="orginSplitOrderInfo.orderStatus"
                  placeholder="请选择"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="(item,index) in orderStatusOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量">
                <el-input
                  v-model="orginSplitOrderInfo.goodsCount"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="退货数">
                <el-input
                  v-model="orginSplitOrderInfo.refundCount"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="销毁数">
                <el-input
                  v-model="orginSplitOrderInfo.destroyCount"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="是否FBA">
                <el-select
                  v-model="orginSplitOrderInfo.orderType"
                  placeholder="请选择"
                  size="small"
                  disabled
                >
                  <el-option
                    key="0"
                    value="0"
                    label="是"
                  ></el-option>
                  <el-option
                    key="1"
                    value="1"
                    label="否"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select
                  v-model="orginSplitOrderInfo.categoryFlag"
                  placeholder="请选择"
                  size="small"
                  disabled
                >
                  <el-option
                    key="1"
                    value="1"
                    label="是"
                  ></el-option>
                  <el-option
                    key="0"
                    value="0"
                    label="否"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
        <el-col
          :span="12"
          class="split-col"
        >
          <el-form
            :model="splitOrderInfo"
            :rules="splitFormRules"
            ref="splitForm"
            label-width="120px"
            class="split-form"
          >
            <div class="split-title">
              拆出订单信息：
            </div>
            <div>
              <el-form-item label="订单状态">
                <el-select
                  v-model="splitOrderInfo.orderStatus"
                  placeholder="请选择"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="(item,index) in orderStatusOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="FBA/YFF/ZOZO/RSL">
                <el-select
                  v-model="splitOrderInfo.orderType"
                  placeholder="请选择"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="item in fbaOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  > </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select
                  v-model="splitOrderInfo.categoryFlag"
                  placeholder="请选择"
                  size="small"
                  disabled
                >
                  <el-option
                    key="1"
                    value="1"
                    label="是"
                  ></el-option>
                  <el-option
                    key="0"
                    value="0"
                    label="否"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="数量"
                prop="goodsCount"
              >
                <el-input v-model="splitOrderInfo.goodsCount"></el-input>
              </el-form-item>
              <el-form-item
                label="退货数"
                prop="refundCount"
              >
                <el-input v-model="splitOrderInfo.refundCount"></el-input>
              </el-form-item>
              <el-form-item
                label="销毁数"
                prop="destroyCount"
              >
                <el-input v-model="splitOrderInfo.destroyCount"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="form-btn btn-gray"
          @click="splitDialogVisible = false"
        >取 消</el-button>
        <el-button
          class="form-btn btn-blue"
          @click="splitSave('splitForm')"
        >提 交</el-button>
      </span>
    </el-dialog>
    <!--图片放大-->
    <el-dialog
      title=""
      :visible.sync="bigvisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      center
    >
      <el-upload
        class="editor-slide-upload bigimg"
        action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
        :data="imgDataObj"
        :multiple="false"
        ref="uploads"
        :file-list="replyInfo.imgFileList"
        :show-file-list="true"
        list-type="picture-card"
        :on-remove="handleImgRemove2"
        :on-success="handleImgSuccess2"
        :before-upload="beforeImgUpload"
        accept="image/png,image/jpeg"
        :limit="1"
      >
        <el-button
          size="small"
          type="primary"
        >点击上传</el-button>
      </el-upload>

      <div style="text-align:right;">
        <el-button
          class="form-btn btn-gray"
          @click="imgDialogClose"
        >取 消</el-button>
        <el-button
          class="form-btn btn-blue"
          @click="imgSave('replyInfo')"
        >提 交</el-button>
      </div>
    </el-dialog>
    <!-- 新建装箱单 -->
    <packing-order ref="packing" @success="refreshList" />
    <!-- 列选择 -->
    <lx-sort
      :visible.sync="isVisibleSort"
      :list="columns"
      @confirm="doSaveColumns"
    ></lx-sort>
  </div>
</template>

<script>
import { columns as originColumns } from "./arrivalOrdersColumns";
import { filterList } from "@/assets/js/utils";
import LxSort from "@/components/LxSort/index";
import tableCon from "../../views/tableContainer";
import Oss from "@/assets/js/oss.js";
import packingOrder from './components/packingOrder'
export default {
  name: 'arrivalOrders',
  // name: 'order/ArrivalOrders',
  components: {
    LxSort,
    tableCon,
    packingOrder
  },
  data() {
    // 自定义手机号校验规则
    const checkMobile = (rule, value, callback) => {
      const regMobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (regMobile.test(value)) {
        callback();
      } else {
        callback(new Error("请输入合法的手机号"));
      }
    };
    //自定义校验产品数量
    const checkGoodsCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) <= 0 || parseInt(value) >= parseInt(this.orginSplitOrderInfo.goodsCount)) {
          callback(new Error("数量应大于0小于原数量"));
        }
        callback();
      } else {
        callback(new Error("请输入数量"));
      }
    };
    const checkRefundCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.orginSplitOrderInfo.refundCount)) {
          callback(new Error("退货数应大于等于0小于等于原退货数"));
        }
        callback();
      } else {
        callback(new Error("请输入退货数"));
      }
    };
    const checkDestroyCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.orginSplitOrderInfo.destroyCount)) {
          callback(new Error("销毁数应大于等于0小于等于原销毁数"));
        }
        callback();
      } else {
        callback(new Error("请输入销毁数"));
      }
    };
    return {
      isActive:false,
      buyAcountList: [],
      curIndex: '',
      fbaOption: [
        {
          label: '否',
          value: '1'
        },
        {
          label: 'FBA',
          value: '0'
        },
        {
          label: 'YFF',
          value: '2'
        },
        {
          label: 'ZOZO',
          value: '3'
        },
        {
          label: 'RSL',
          value: '4'
        },
      ],
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      orderList: [],
      menuSettingData: {
        menuId: 'staffArrivalOrders'
      },
      bigvisible: false,
      imgurl: '',
      queryInfo: {
        id: '',
        trackingNumberCn: '',
        trackingNumberJpn: '',
        sagawaState: '',
        orderStatus: '',
        customerName: '',
        userName: '',
        receiver: '',
        categoryFlag: '',
        createTimeStart: '',
        createTimeEnd: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        orderType: '',
        goodsCode: '',
        pageSize: 10,
        pageNum: 1,
      },
      // orderDateRangeValue:[],
      // shipDateRangeValue:[],
      orderStatusOptions: [],
      orderCount: {
        total: 0,
        arrivalCount: 0,
        checkingCount: 0,
        checkedCount: 0,
        warehouseStorageCount: 0,
        applySendCount: 0,
        waitPayCount: 0,
        boxCount: 0,
        waitSendCount: 0
      },
      splitDialogVisible: false,
      orginSplitOrderInfo: {},
      splitOrderInfo: {
      },
      splitForm: {
      },
      splitFormRules: {
        goodsCount: [
          { required: true, message: "请输入数量", trigger: "change" },
          { validator: checkGoodsCount }
        ],
        refundCount: [
          { required: true, message: "请输入退货数", trigger: "change" },
          { validator: checkRefundCount }
        ],
        destroyCount: [
          { required: true, message: "请输入销毁数", trigger: "change" },
          { validator: checkDestroyCount }
        ]
      },
      total: 0,
      editStatus: ["52", "56", "72", "84"],
      spiltStatus: ["4", "8", "12", "16"],
      billStatus: ["12", "20", "44", "48", "88"],
      // 图片粘贴相关
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      replyInfo: {
        orderId: '',
        remindingUserName: '',
        remindingTitle: '',
        remindingTitleJa: '',
        remindingContent: '',
        url: '',
        replyPicture: '',
        imgFileList: [],
        imgFileListStr: ''
      },
      bigimglist: {
        orderId: '',
        pictureUrl: '',
        upfile: '',
      },
      listObj: [],
      // picture end
      scrollListener: null,
      scrollTopCache: 0
    };
  },
  created() {
    this.getAsyncColumns().then(() => {
      this.getOrderCount();
      this.getOrderList();
      this.getBuyAccountList();
    });
  },
  mounted () {
    this.restoreScroll()
  },
  methods: {
    restoreScroll() {
      const bodyWrapper = this.$refs.multipleTable.$el.querySelector('.el-table__body-wrapper');
      this.scrollListener = () => {
        this.scrollTopCache = bodyWrapper.scrollTop;
      };
      bodyWrapper.addEventListener('scroll', this.scrollListener);
      // 如果有缓存滚动位置，恢复
      if (this.scrollTopCache) {
        setTimeout(() => {
          bodyWrapper.scrollTop = this.scrollTopCache;
        },100)
      }
    },
    createPacking() {
      this.$refs.packing.openPacking();
    },
    refreshList() {
      this.getAsyncColumns().then(() => {
        this.getOrderCount();
        this.getOrderList();
        this.getBuyAccountList();
      });
    },
    // picture Ctrl+V start
    imgclick(url, index) {
      this.index = index
      this.bigvisible = true
      if (url.pictureUrl == "" || url.pictureUrl == undefined) {
        this.$nextTick(() => {
          var su = document.getElementsByClassName('el-upload--picture-card')[0]
          su.style.display = 'block'
          this.replyInfo.imgFileList = []
        })
      } else {
        this.$nextTick(() => {
          var su = document.getElementsByClassName('el-upload--picture-card')[0]
          su.style.display = 'none'
          this.replyInfo.imgFileList = [{
            url: url.pictureUrl
          }]
        })
      }
      this.bigimglist.orderId = url.id
      var su = document.getElementsByClassName('el-upload-list__item')[0]
      document.addEventListener('paste', this.onPasteUpload)
    },
    onPasteUpload(event) {
      event.stopPropagation()
      let text = (event.clipboardData || window.clipboardData);
      this.bigimglist.upfile = text.files[0]
      this.bigimglist.pictureUrl = ''
      if (text.files[0] === null) {
        this.$message.error('仅支持图片文件')
      } else {
        // 将文件流转换为img认识的格式放在页面
        let blob = new Blob([text.files[0]]); // 返回的文件流数据
        let url = window.URL.createObjectURL(blob); // 将他转化为路径
        this.replyInfo.imgFileList = [{ url }]
        var su = document.getElementsByClassName('el-upload--picture-card')[0]
        this.$nextTick(() => {
          su.style.display = 'none'
        })
      }
    },
    handleImgRemove2(file) {
      Oss.imgRemove(file, this.listObj);
      var su = document.getElementsByClassName('el-upload--picture-card')[0]
      this.$nextTick(() => {
        su.style.display = 'block'
      })
      this.bigimglist.upfile = ''
      this.bigimglist.pictureUrl = ''
    },
    handleImgSuccess2(response, file, fileList) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj)
      var su = document.getElementsByClassName('el-upload--picture-card')[0]
      this.$nextTick(() => {
        su.style.display = 'none'
      })

    },
    beforeImgUpload(file) {
      const _self = this;
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        _self.$message.error('请上传jpg,jpeg,png格式的图片！');
        return false
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/
      if (specialReg.test(file.name)) {
        _self.$message.error('文件名中不能包含以下字符 ，；：｛｝* 请检查后修改文件名后再上传');
        return false
      }
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/order/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/order';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          file.timeStamp = num
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          reject(true)
        })
      })
    },
    imgDialogClose() {
      this.bigvisible = false
      if (this.replyInfo.imgFileList.length === 0) {
        var su = document.getElementsByClassName('el-upload--picture-card')[0]
        this.$nextTick(() => {
          su.style.display = 'block'
        })
      } else {
        var su = document.getElementsByClassName('el-upload--picture-card')[0]
        this.$nextTick(() => {
          su.style.display = 'none'
        })
      }
    },
    imgSave() {
      this.handleImgSubmit();

      if (this.replyInfo.replyPicture.indexOf(',')) {
        this.replyInfo.replyPicture = this.replyInfo.replyPicture.split(',')[1]
      }

      if (this.bigimglist.upfile === '') {
        this.bigimglist.pictureUrl = this.replyInfo.replyPicture
      } else {
        this.bigimglist.pictureUrl = ''
      }
      this.replyInfo.imgFileList = this.replyInfo.imgFileList.splice(1, 1)
      this.uploadFile()
    },
    handleImgSubmit() {
      var _this = this;
      let arr = []
      Object.keys(_this.listObj).map(v => {
          arr.push(_this.listObj[v])
      });
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
        return
      }
      else {
        if (arr.length > 1) {
          _this.$message.error('最多可上传1张图片');
        }
        else {
          _this.replyInfo.imgFileList = _this.replyInfo.imgFileList.concat(arr);
          var urlArr = [];
          _this.replyInfo.imgFileList.forEach(el => {
              urlArr.push(el.url);
          })
          _this.replyInfo.replyPicture = urlArr.toString();
          _this.$emit('successCBK', arr);
          _this.listObj = {};
          _this.imgDialogVisible = false;

        }
      }
    },
    async uploadFile() {
      var formdata = new FormData
      formdata.append('orderId', this.bigimglist.orderId)
      var su = this.orderList[this.index].pictureUrl
      this.bigimglist.pictureUrl === undefined ? formdata.append('pictureUrl', su) : formdata.append('pictureUrl', this.bigimglist.pictureUrl)

      formdata.append('upfile', this.bigimglist.upfile)
      const { data: res } = await this.$http.post("order/uploadFile", formdata);
      if (res.code === 200) {
        this.$message.success('上传成功')
        this.bigvisible = false;
        this.getOrderCount();
        this.getOrderList();
      } else {
        this.$message.error(res.message)
      }
    },
    // picture Ctrl+V start
    changeTab(index) {
      this.curIndex = index
      this.searchList()
    },
    //快速保存
    async quickSave(value, type, id) {
      if (type === '0') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, productDesc: value, quickSaveType: type });
      } else if (type === '1') {
        if (!value && value !== 0) {
          this.$message.error('中国运费不能设置为空')
        } else if ((value.split('')[0] == 0 && value.split('')[1] == 0) || (value.split('')[0] == 0 && value.split('').length > 1 && value.split('')[1] !== '.')) {
          this.$message.error('请正确输入运费！')
        } else {
          const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, chineseFreightFee: value, quickSaveType: type });
        }
      } else if (type === '2') {
        if (value && Number(value) > 0) {
          const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, price: value, quickSaveType: type });
        } else {
          this.$message.error('单价不能设置为空')
        }
      } else if (type === '3') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, buyOrderNumber: value, quickSaveType: type });
      } else if (type === '4') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, buyAccountId: value, quickSaveType: type });
      } else if (type === '5') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, staffRemark: value, quickSaveType: type });
      } else if (type === '6') {
        const { data: res } = await this.$http.post("/order/quickSave", { orderId: id, checkRemark: value, quickSaveType: type });
      }
    },
    //获取购买账号
    getBuyAccountList() {
      this.$http.get('cms/configAccountNumber/getAllList').then(res => {
        this.buyAcountList = res.data.data;
        this.buyAcountList.map(res => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case '0':
                return res.platformType_hanzi = '淘宝 -' + res.accountNumber
                break;
              case '1':
                return res.platformType_hanzi = '1688 -' + res.accountNumber
                break;
              case '2':
                return res.platformType_hanzi = '京东 -' + res.accountNumber
                break;
              case '3':
                return res.platformType_hanzi = '拼多多 -' + res.accountNumber
                break;
              case null:
                return res.platformType_hanzi = ''
                break;

            }
          }
        })
      })
    },
    // 获取已选择列
    getAsyncColumns() {
      return new Promise((resolve) => {
        // 接口start
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'staffArrivalOrders'
          }
        }).then((res) => {
          var result = [];
          if (res.data.code === 200) {
            var record = res.data.data;
            this.menuSettingData = record;
            result = JSON.parse(record.menuSetting);
          }
          if (result && result.length > 0) {
            result.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            let noSelectList = filterList(
              this.originColumns,
              result,
              "columnId"
            );
            this.columns = result.concat(noSelectList);
            this.asyncColumns = result;
            resolve();
          } else {
            this.columns = this.originColumns;
            this.columns.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            this.asyncColumns = this.columns;
            resolve();
          }
        });
      });
    },
    // 保存选择的列
    doSaveColumns(list) {
      var my = this;
      // 接口
      let url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then(res => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: "保存成功",
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getOrderList();
          });
        } else {
          my.$message({
            type: "warning",
            message: "保存失败",
          });
        }
      })
    },
    // 排序
    toSort() {
      this.isVisibleSort = true;
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    orderDateRange() {

    },
    shipDateRange() {

    },
    queryInfoClear() {
      this.curIndex = '',
        this.queryInfo.userName = '',
        this.queryInfo.id = '',
        this.queryInfo.trackingNumberCn = '',
        this.queryInfo.trackingNumberJpn = '',
        this.queryInfo.sagawaState = '',
        this.queryInfo.orderStatus = '',
        this.queryInfo.customerName = '',
        this.queryInfo.receiver = '',
        this.queryInfo.categoryFlag = '',
        this.queryInfo.createTimeStart = '',
        this.queryInfo.createTimeEnd = '',
        this.queryInfo.sendTimeStart = '',
        this.queryInfo.sendTimeEnd = '',
        this.queryInfo.orderType = '',
        this.queryInfo.goodsCode = '',
        this.queryInfo.pageSize = 10,
        this.queryInfo.pageNum = 1
      // this.orderDateRangeValue = [];
      // this.shipDateRangeValue = [];
    },
    searchList(status, index) {
      this.queryInfo.orderStatus = this.curIndex;
      this.queryInfo.pageNum = 1;
      this.getOrderCount();
      this.getOrderList();
    },
    categoryFlagChanged(row) {
      //改变状态接口 params row.No,row.categoryFlag
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag;
        alert('failed')
      }, 1000);

    },
    async getOrderList() {
      this.isLoading = true;
      const { data: res } = await this.$http.get("empArrOrder/list", { params: this.queryInfo });
      this.orderList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false;
      // 重新计算表格布局
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
    async getOrderCount() {
      const { data: res } = await this.$http.get("empArrOrder/arrivalOrderCount", { params: this.queryInfo });
      this.orderCount = res.data;
      this.$forceUpdate();
    },
    toGoodsDetail(row) {
      this.$http.get('/purchase/changeUrlAction', { params: { url: row.taobaoUrl } }).then((res) => {
        const changeUrl = res.data.data;
        console.log(changeUrl);
        window.open(changeUrl, "_blank");
      });
      /*this.$http.post("/order/changeUrl", { taobaoUrl: row.taobaoUrl }).then(res => {
        const changeUrl = res.data.data;
        window.open(changeUrl, '_blank')
      });*/
    },
    toOrderDetail(row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: '0'
        }
      })
    },
    toEditOrder(row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: '1'
        }
      })
    },
    splitOrder(row) {
      this.splitDialogVisible = true;
      this.orginSplitOrderInfo = row;
      this.splitOrderInfo = JSON.parse(JSON.stringify(row));
      // console.log(this.splitOrderInfo);
    },
    splitDialogClosed() {
      console.log('close');
      this.splitDialogVisible = false;
    },
    splitSave(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(this.splitOrderInfo);
          const { data: res } = await this.$http.post('empArrOrder/spilt', this.splitOrderInfo);
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.splitDialogClosed();
            await this.getOrderCount();
            await this.getOrderList();
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      });
    },
    saveRemark(row) {
      this.savePost(row);
    },
    async savePost(row) {
      console.log("id：" + row.id);
      console.log("工作签：" + row.staffRemark);
      const { data: res } = await this.$http.post('order/updateOrderInfo', { orderId: row.id, staffRemark: row.staffRemark });
      if (res.code === 200) {
        await this.getOrderCount();
        await this.getOrderList();
      }
      else {
        this.$message.error(res.message);
        await this.getOrderCount();
        await this.getOrderList();
      }
    },
    toBill(row) {
      this.$router.push({
        path: 'orders/bill',
        query: {
          id: row.id,
          isAdd: '0',
          //orderNumber:e.orderNumber,
        }
      })
    },

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getOrderCount();
      this.getOrderList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getOrderCount();
      this.getOrderList();
    },
    //播放视频
    handlePlayVideo(param){
      window.open(param,'_blank');
    }

  },
  watch: {
    // orderDateRangeValue(){
    //   this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
    //   this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
    //   console.log(this.orderDateRangeValue);
    // },
    // shipDateRangeValue(){
    //   this.queryInfo.sendTimeStart = this.shipDateRangeValue[0];
    //   this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1];
    // }
  },
  activated () {
    this.restoreScroll()
  },
  // 离开页面
  deactivated() {
    const bodyWrapper = this.$refs.multipleTable.$el.querySelector('.el-table__body-wrapper');
    bodyWrapper.removeEventListener('scroll', this.scrollListener);
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}
.div{
  display: flex;
  width: 100%;
  .table-cell-title-min-new{
    display: block;
    width: 70px;
    text-align: right;
  }
  .span{
    flex: 1;
    text-align: left;
  }
}
</style>

<style lang="less" scoped>
/deep/ /*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}
.bigimg /deep/ ul li {
  width: 100%;
  height: auto;
}
.bigimg /deep/ .el-upload--picture-card {
  display: none;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}
.mark {
  background: #dbdb86;
  text-align: left;
  margin-bottom: 10px;
}
.el-icon-close {
  cursor: pointer;
}
</style>
